export default "__VITE_ASSET__PkY5yLzl__"